import api from "@/store/api";
import Message from "@/store/messages";
import axios from "axios";

const cleanQuery = (obj) => {
  const query = new URLSearchParams();
  Object.keys(obj).forEach((key) => {
    if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
      delete obj[key];
    } else if (obj[key] instanceof Array) {
      if (obj[key].length === 0) {
        delete obj[key];
      } else {
        //console.log(obj[key]);
        obj[key].forEach((entry) => {
          query.append(key, entry);
        });
        //query.append(key, obj[key].join(","));
      }
    } else {
      query.append(key, obj[key]);
    }
  });
  return query.toString();
};

let abortController = new AbortController();
const asyncPagination = {
  namespaced: true,
  state: () => ({
    lock: false,
    route: "",
    context: "",
    lastRequest: "",
    reload: false,
    data: {},
    limit: 100,
    lastResponse: null,
    pagination: {
      isLoading: true,
      allLoaded: false,
      infinite_scroll: false,
      initial: true,
      currentSort: "_id",
      currentSortDir: "asc",
      pageSize: 100,
      defaultPageSize: 100,
      currentPageSize: 0,
      maxLength: 500,
      pageCount: 1,
      currentPage: 1,
      filter: "",
      filterObject: {},
      currentFilter: {},
      listLength: 1,
      listSize: 1,
      list: [],
    },
  }),
  getters: {
    context(state) {
      return state.context;
    },
    pagination(state) {
      return state.pagination;
    },
    list(state) {
      return state.pagination.list;
    },
    currentSort(state) {
      return state.pagination.currentSort;
    },
    currentSortDir(state) {
      return state.pagination.currentSortDir;
    },
    pageSize(state) {
      return state.pagination.pageSize;
    },
    currentPage(state) {
      return state.pagination.currentPage;
    },
    pageCount(state) {
      return state.pagination.pageCount;
    },
    filter(state) {
      return state.pagination.filter;
    },
    filterObject(state) {
      return state.pagination.filterObject;
    },
    listLength(state) {
      return state.pagination.listLength;
    },
    toQuery(state, getters) {
      const setting = getters.settingsQuery;
      const sort = getters.sortQuery ? "&" + getters.sortQuery : "";
      const search = getters.searchQuery ? "&" + getters.searchQuery : "";
      const filter = getters.filterQuery ? "&" + getters.filterQuery : "";
      return "?" + setting + sort + search + filter;
    },
    settingsQuery(state) {
      const settings = {
        limit: state.limit,
      };
      if (state.pagination.currentPage > 1) {
        settings["skip"] = state.limit * (state.pagination.currentPage - 1);
      }
      if (
        state.pagination.currentPageSize <= state.pagination.defaultPageSize
      ) {
        settings["full_count"] = true;
      }
      return cleanQuery(settings);
    },
    sortQuery(state) {
      return cleanQuery({
        sort: state.pagination.currentSort,
        sort_dir: state.pagination.currentSortDir,
      });
    },
    searchQuery(state) {
      return cleanQuery({ search: state.pagination.filter });
    },
    filterQuery(state) {
      return cleanQuery({ ...state.pagination.filterObject });
    },
    allLoaded(state) {
      return state.pagination.allLoaded;
    },
  },
  mutations: {
    // We need this mutation to use the vca tables
    pagination() {
      return;
    },
    setLimit(state, value) {
      state.limit = value;
    },
    adjustPageSize(state) {
      if (state.pagination.pageSize < state.pagination.listLength) {
        state.pagination.pageSize =
          state.pagination.listLength < state.pagination.defaultPageSize
            ? state.pagination.listLength
            : state.pagination.defaultPageSize;
      }
    },
    setInfiniteScroll(state) {
      state.pagination.infinite_scroll = true;
    },
    route(state, value) {
      state.route = value;
    },
    filterObject(state, value) {
      state.filterObject = value;
    },
    context(state, value) {
      state.context = value;
    },
    firstPage(state) {
      state.pagination.currentPage = 1;
      this.dispatch(state.context + "/request");
    },
    lastPage(state) {
      state.pagination.currentPage = state.pagination.pageCount;
      this.dispatch(state.context + "/request");
    },
    prevPage(state) {
      if (state.pagination.currentPage > 1) {
        state.pagination.currentPage--;
        this.dispatch(state.context + "/request");
      }
    },
    nextPage(state) {
      if (state.pagination.currentPage < state.pagination.pageCount) {
        state.pagination.currentPage++;
        this.dispatch(state.context + "/request");
      }
    },
    pageSize(state, value) {
      const pageSize = state.pagination.pageSize;
      if (parseInt(value) > 0) {
        state.pagination.pageSize =
          parseInt(value) > state.pagination.maxLength
            ? state.pagination.maxLength
            : parseInt(value);
      } else {
        state.pagination.pageSize = 1;
      }
      state.pagination.pageCount =
        state.pagination.listLength > 0
          ? Math.ceil(state.pagination.listSize / state.pagination.pageSize)
          : 1;

      if (state.pagination.pageCount < state.pagination.currentPage) {
        this.commit(state.context + "/currentPage", state.pagination.pageCount);
      } else if (state.reload && pageSize !== parseInt(value)) {
        state.reload = false;
        this.dispatch(state.context + "/request");
      }
    },
    currentPageSize(state, value) {
      state.pagination.currentPageSize =
        value > state.pagination.maxLength ? state.pagination.maxLength : value;
    },
    currentPage(state, value) {
      const oldVal = state.pagination.currentPage;
      state.pagination.currentPage =
        value > state.pagination.pageCount
          ? state.pagination.currentPage
          : value;
      if (oldVal != value && value <= state.pagination.pageCount) {
        this.dispatch(state.context + "/request");
      }
    },
    listLength(state, value) {
      state.pagination.listLength = value > 0 ? value : 1;
      state.pagination.pages =
        value > 0 ? Math.ceil(value / state.pagination.pageSize) : 1;
      state.pagination.pageCount =
        value > 0 ? Math.ceil(value / state.pagination.pageSize) : 1;
      state.pagination.currentPage =
        state.pagination.pageCount < state.pagination.currentPage
          ? state.pagination.pageCount
          : state.pagination.currentPage;
    },
    listLengthSimple(state, value) {
      state.pagination.listLength = value;
    },
    pageCount(state) {
      if (state.pagination.listSize > 1) {
        if (
          state.pagination.listSize == state.pagination.pageSize &&
          state.pagination.currentPageSize == 1
        ) {
          state.pagination.pageCount = state.pagination.currentPage + 1;
        } else {
          state.pagination.pageCount = state.pagination.currentPage;
        }
      } else {
        state.pagination.pageCount = 1;
        state.pagination.currentPage = 1;
      }
    },
    handleResponse(state, response) {
      if (!response.data) {
        return;
      }
      state.lastResponse = response;
      state.pagination.list = response.data.payload;

      const list_size = response.data.list_size ? response.data.list_size : 1;
      state.pagination.listSize = list_size;

      state.pagination.currentPageSize = 0;
      state.pagination.list = response.data.payload
        ? response.data.payload
        : [];
      state.reload = true;
      this.commit(
        state.context + "/pageSize",
        state.pagination.list.length.toString()
      );
      this.commit(state.context + "/listLength", response.data.list_size);

      state.lock = false;
      state.data = {};
      state.pagination.isLoading = false;
    },
    currentSort(state, val) {
      state.pagination.currentSort = val;
    },
    currentSortDir(state, val) {
      state.pagination.currentSortDir = val;
    },
    handleIScrollResponse(state, response) {
      if (!response.data) {
        return;
      }
      state.lastResponse = response;
      if (response.data.payload.length == 0) {
        state.pagination.allLoaded = true;
      } else {
        state.pagination.list.push(...response.data.payload);
        state.pagination.currentPage += 1;
        state.pagination.currentPageSize = 0;
      }
      state.reload = true;
      let list_size = response.data.list_size ? response.data.list_size : 0;
      if (state.pagination.list.length > response.data.list_size) {
        list_size = state.pagination.list.length;
      }
      this.commit(state.context + "/listLengthSimple", list_size);

      state.lock = false;
      state.data = {};
      state.pagination.isLoading = false;
    },
  },
  actions: {
    sort({ state, dispatch }, data) {
      if (state.pagination.currentSort == data.col) {
        state.pagination.currentSortDir =
          state.pagination.currentSortDir == "desc" ? "asc" : "desc";
      }
      state.pagination.currentSort = data.col;
      if (state.pagination.infinite_scroll) {
        dispatch({
          type: "request",
          data: { initial: true, infinite_scroll: true },
        });
      } else {
        dispatch({ type: "request" });
      }
    },
    request(
      { state, commit, getters },
      data = { initial: false, abort: false, infinite_scroll: false }
    ) {
      if (data.data?.initial == true) {
        state.pagination.currentPage = 1;
        state.pagination.list = [];
      }
      if (data.data && data.data.abort) {
        state.lock = false;
        state.pagination.isLoading = false;
        abortController.abort();
        abortController = new AbortController();
      }
      state.pagination.allLoaded = false;
      state.data = data;
      if (state.lock == false) {
        const q = getters.toQuery;
        state.pagination.isLoading = true;
        state.lock = true;
        if (
          state.lastRequest == q &&
          state.lastResponse &&
          (!data.data || (data.data && data.data.initial == false))
        ) {
          commit("handleResponse", state.lastResponse);
          if (data.data?.infinite_scroll) {
            commit("handleIScrollResponse", state.lastResponse);
          } else {
            commit("handleResponse", state.lastResponse);
          }
          return;
        }
        state.lastRequest = q;
        return new Promise((resolve, reject) => {
          api
            .get(state.route + q, {
              signal: abortController.signal,
            })
            .then((response) => {
              if (data.data?.infinite_scroll) {
                commit("handleIScrollResponse", response);
              } else {
                commit("handleResponse", response);
              }
              abortController = new AbortController();
              resolve(response.data.payload);
            })
            .catch((error) => {
              if (!axios.isCancel(error)) {
                state.lock = false;
                state.pagination.isLoading = false;
                commit(
                  "currentMsg",
                  Message.getMessage("error", "error.unknown"),
                  { root: true }
                );
                abortController = new AbortController();
                reject(error);
              }
            });
        });
      }
    },
  },
};

export default asyncPagination;
export { cleanQuery };
